module.exports = __webpack_public_path__ + "static/media/financiacion_brilla_opc2.5db6fe0f.jpg";